import React from "react"
import { makeStyles } from "@material-ui/core"
import { Divider } from "@material-ui/core"
import { StaticImage } from "gatsby-plugin-image"

import Seo from "../components/SEO"
import Layout from "../components/Layout"
import InstagramImages from "../components/InstagramImages"
import MessageSection from "../components/MessageSection"

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: "black",
  },
}))

const IndexPage = () => {
  const classes = useStyles()
  return (
    <Layout>
      <Seo
        title="東松山市のヘアカラー専門美容室BIGHEAD"
        description="埼玉県東松山市の美容室BIGHEAD『カラーの魔術師』公式サイト。おしゃれ染め・白髪染め・デザインカラー・ブリーチなど、ダメージを抑えた発色にこだわるヘアカラー専門の施術コンセプト。駐車場7台完備。"
        pathname="/"
      />
      <h1 className="visually-hidden">
        埼玉県東松山市の美容室BIGHEAD ヘアカラー施術コンセプト『カラーの魔術師』
      </h1>
      <div className={classes.root}>
        <div className="sp-block">
          <StaticImage
            src="../images/sp_top_kv.jpg"
            alt="カラーの魔術師 メインビジュアル"
            placeholder="blurred"
            layout="fullWidth"
          />
        </div>
        <div className="pc-block">
          <StaticImage
            src="../images/pc_top_kv.jpg"
            alt="カラーの魔術師 メインビジュアル"
            placeholder="blurred"
            layout="fullWidth"
          />
        </div>
        <InstagramImages />
        <Divider
          style={{
            color: "white",
            backgroundColor: "white",
            width: "100%",
          }}
        />
        <MessageSection />
      </div>
    </Layout>
  )
}

export default IndexPage
